export default "__VITE_ASSET__DUdHEXCI__"